import { ReactNode } from "react";

type ImageUrl = {
    desktop: string;
    mobile: string;
}

export type SymptomSlide = {
    category: string;
    bgImageUrl: ImageUrl;
    title: string;
    description: ReactNode;
    mobileDescription: ReactNode;
    learnMoreHref: string;
    learnMoreAccessibleSuffix: string;
    quote: string;
    authorImageUrl: ImageUrl;
};

export const SYMPTOM_SLIDES: SymptomSlide[] = [
    {
        category: "Hormone Imbalance",
        bgImageUrl: {
            desktop: "https://res.cloudinary.com/dirscuuhp/image/upload/v1789301145/new_design/image_2_ifvz0g.webp",
            mobile: "https://res.cloudinary.com/dirscuuhp/image/upload/v1790671309/new_design/Frame_2147205867_fylxfg.webp",
        },
        title: "Hormone Imbalance",
        description: <>Restore estrogen and progesterone levels when <br />your hormones fall out of balance.</>,
        mobileDescription: "Restore the levels your body's missing.",
        learnMoreHref: "/treatment/hrt",
        learnMoreAccessibleSuffix: " about hormone imbalance treatment",
        quote: "Hormone fluctuations can affect women at every life stage – not just menopause.",
        authorImageUrl: {
            desktop: "https://res.cloudinary.com/dirscuuhp/image/upload/v1789332552/new_design/image_2_kuqnjf.webp",
            mobile: "https://res.cloudinary.com/dirscuuhp/image/upload/v1789332635/new_design/Frame_1171278016_kctdwh.webp",
        }
    },
    {
        category: "Perimenopause",
        bgImageUrl: {
            desktop: "https://res.cloudinary.com/dirscuuhp/image/upload/v1789301145/new_design/CTA_Card_do4ubu.webp",
            mobile: "https://res.cloudinary.com/dirscuuhp/image/upload/v1790671309/new_design/Frame_2147205868_qi8bxw.webp",
        },
        title: "Perimenopause",
        description: <>Stabilize shifting hormones behind changes in <br />sleep, mood, cycles, and energy.</>,
        mobileDescription: "Stabilize shifting hormones behind changes in sleep, mood, cycles, and energy.",
        learnMoreHref: "/treatment/perimenopause",
        learnMoreAccessibleSuffix: " about perimenopause treatment",
        quote: "The right care can make hormonal transitions feel understood and manageable.",
        authorImageUrl: {
            desktop: "https://res.cloudinary.com/dirscuuhp/image/upload/v1789332552/new_design/image_2_kuqnjf.webp",
            mobile: "https://res.cloudinary.com/dirscuuhp/image/upload/v1789332635/new_design/Frame_1171278016_kctdwh.webp",
        }
    },
    {
        category: "Menopause",
        bgImageUrl: {
            desktop: "https://res.cloudinary.com/dirscuuhp/image/upload/v1789301145/new_design/image_2_1_xxny22.webp",
            mobile: "https://res.cloudinary.com/dirscuuhp/image/upload/v1790671309/new_design/Frame_ygbvnf.webp",
        },
        title: "Menopause",
        description: <>Replenish estrogen and progesterone as <br />levels decline during menopause.</>,
        mobileDescription: "Replenish estrogen and progesterone as levels decline during menopause.",
        learnMoreHref: "/treatment/menopause",
        learnMoreAccessibleSuffix: " about menopause treatment",
        quote: "Menopause care should be built around the whole person, not a symptom checklist.",
        authorImageUrl: {
            desktop: "https://res.cloudinary.com/dirscuuhp/image/upload/v1789332552/new_design/image_2_kuqnjf.webp",
            mobile: "https://res.cloudinary.com/dirscuuhp/image/upload/v1789332635/new_design/Frame_1171278016_kctdwh.webp",
        }
    },
    {
        category: "Endometriosis",
        bgImageUrl: {
            desktop: "https://res.cloudinary.com/dirscuuhp/image/upload/v1789301145/new_design/CTA_Card_1_k8saa6.webp",
            mobile: "https://res.cloudinary.com/dirscuuhp/image/upload/v1790671309/new_design/Frame_1_hpqkkj.webp",
        },
        title: "Endometriosis",
        description: <>Support hormonal balance when endometriosis <br />contributes to painful, disruptive cycles.</>,
        mobileDescription: "Support hormonal balance when endometriosis contributes to painful, disruptive cycles.",
        learnMoreHref: "/treatment/endometriosis",
        learnMoreAccessibleSuffix: " about endometriosis treatment",
        quote: "Women deserve care that takes their pain seriously and looks for lasting relief.",
        authorImageUrl: {
            desktop: "https://res.cloudinary.com/dirscuuhp/image/upload/v1791276185/new_design/image_Sarah_myhyz2.webp",
            mobile: "https://res.cloudinary.com/dirscuuhp/image/upload/v1789332635/new_design/Frame_1171278016_kctdwh.webp",
        }
    },
    {
        category: "Postpartum",
        bgImageUrl: {
            desktop: "https://res.cloudinary.com/dirscuuhp/image/upload/v1789301146/new_design/CTA_Card_2_srrf02.webp",
            mobile: "https://res.cloudinary.com/dirscuuhp/image/upload/v1790671309/new_design/Frame_2_kiluay.webp",
        },
        title: "Postpartum",
        description: <>Replenish hormonal support after the <br />dramatic shifts of pregnancy and birth.</>,
        mobileDescription: "Replenish hormonal support after the dramatic shifts of pregnancy and birth.",
        learnMoreHref: "/treatment/postpartum",
        learnMoreAccessibleSuffix: " about postpartum treatment",
        quote: "Postpartum recovery deserves the same attention and support as pregnancy.",
        authorImageUrl: {
            desktop: "https://res.cloudinary.com/dirscuuhp/image/upload/v1791276185/new_design/image_Sarah_myhyz2.webp",
            mobile: "https://res.cloudinary.com/dirscuuhp/image/upload/v1789332635/new_design/Frame_1171278016_kctdwh.webp",
        }
    },
    {
        category: "PCOS",
        bgImageUrl: {
            desktop: "https://res.cloudinary.com/dirscuuhp/image/upload/v1789301145/new_design/CTA_Card_3_gwykqv.webp",
            mobile: "https://res.cloudinary.com/dirscuuhp/image/upload/v1790671309/new_design/Frame_3_m6ftpv.webp",
        },
        title: "PCOS",
        description: <>Support hormonal balance behind irregular cycles and other PCOS symptoms.</>,
        mobileDescription: "Support hormonal balance behind irregular cycles and other PCOS symptoms.",
        learnMoreHref: "/treatment/pcos",
        learnMoreAccessibleSuffix: " about PCOS treatment",
        quote: "PCOS care works best when it reflects each woman’s individual symptoms and goals.",
        authorImageUrl: {
            desktop: "https://res.cloudinary.com/dirscuuhp/image/upload/v1791276185/new_design/image_Sarah_myhyz2.webp",
            mobile: "https://res.cloudinary.com/dirscuuhp/image/upload/v1789332635/new_design/Frame_1171278016_kctdwh.webp",
        }
    },
];
